import { yupResolver } from '@hookform/resolvers/yup';
import { Button, StyledButton, TextField } from '@tryhackme/thm-ui-components';
import { useCallback } from 'react';
import { FeedbackType } from 'src/common/enums/feedback';
import { useForm } from 'src/common/form';
import { type RoomCompletionFeedbackFormInput, roomCompletionFeedbackValidation } from 'src/features/room/components/completion-modal/completion-modal.constants';
import { useProvideRoomCompletionFeedbackMutation } from 'src/features/room/room.slice';
import type { RoomFeedbackInput } from '../completion-modal/completion-modal.types';
import { StyledFeedbackActions, StyledFeedbackForm } from './feedback-form.styles';
export const FeedbackForm = ({
  roomCode,
  setIsFeedbackSent,
  onClose
}: {
  roomCode: string;
  setIsFeedbackSent: (arg: boolean) => void;
  onClose: () => void;
}) => {
  const {
    register,
    reset,
    handleSubmit
  } = useForm<RoomCompletionFeedbackFormInput>({
    resolver: yupResolver(roomCompletionFeedbackValidation),
    mode: 'onSubmit'
  });
  const [provideRoomCompletionFeedback, {
    isLoading: isSavingRoomFeedback
  }] = useProvideRoomCompletionFeedbackMutation();
  const handleSendFeedBack = useCallback(async (feedbackInput: RoomFeedbackInput) => {
    const {
      like,
      dislike,
      feature
    } = feedbackInput;
    try {
      await provideRoomCompletionFeedback({
        roomCode,
        like,
        dislike,
        feature,
        type: FeedbackType.ROOM_FEEDBACK
      }).unwrap();
      reset();
      setIsFeedbackSent(true);
    } catch (error) {
      reset();
      // eslint-disable-next-line no-console
      console.error(error);
    }
    onClose();
  }, [onClose, provideRoomCompletionFeedback, reset, roomCode, setIsFeedbackSent]);
  return <StyledFeedbackForm
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  onSubmit={handleSubmit(handleSendFeedBack)} data-testid="feedback-form" data-sentry-element="StyledFeedbackForm" data-sentry-component="FeedbackForm" data-sentry-source-file="feedback-form.tsx">
      <h2>Let us know how we did!</h2>
      <div>
        <TextField {...register('like')} label="What do you like about the room?" labelPosition="top" placeholder="Type your answer here..." variant="input" id="like" defaultValue="" data-sentry-element="TextField" data-sentry-source-file="feedback-form.tsx" />
      </div>
      <div>
        <TextField {...register('dislike')} label="What don’t you like about the room?" labelPosition="top" placeholder="Type your answer here..." variant="input" id="dislike" defaultValue="" data-sentry-element="TextField" data-sentry-source-file="feedback-form.tsx" />
      </div>
      <div>
        <TextField {...register('feature')} label="Please send your suggestions, ideas and comments!" labelPosition="top" placeholder="Type your answer here..." variant="input" id="feature" defaultValue="" data-sentry-element="TextField" data-sentry-source-file="feedback-form.tsx" />
      </div>
      <StyledFeedbackActions data-sentry-element="StyledFeedbackActions" data-sentry-source-file="feedback-form.tsx">
        <StyledButton onClick={onClose} color="secondary" variant="solid" data-sentry-element="StyledButton" data-sentry-source-file="feedback-form.tsx">
          Cancel
        </StyledButton>
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <Button type="submit" disabled={isSavingRoomFeedback} data-sentry-element="Button" data-sentry-source-file="feedback-form.tsx">
          Send Feedback
        </Button>
      </StyledFeedbackActions>
    </StyledFeedbackForm>;
};